const _ = require('lodash');
const utils = require('./utils');
const nunjucks = require('nunjucks');
const SafeString = nunjucks.runtime.SafeString;

// NB: this needs to be commonjs module,
// so no fancy imports, it won't work.
module.exports = function (env) {
	env.addFilter('date', utils.formatDate);
	env.addFilter('number', utils.formatNumber);
	env.addFilter('minutes', utils.formatMinutes);
	env.addFilter('cssClasses', function () {
		let classes = utils.cssClasses(... arguments);
		if (classes) {
			classes = ' class="' + classes + '"';
		} else {
			classes = '';
		}
		return new SafeString(classes);
	});
	env.addFilter('json', function (value) {
		return JSON.stringify(value);
	});
	env.addFilter('attrs', function () {
		let attrs = Object.assign(Object.create(null), ... arguments);
		if (_.isEmpty(attrs)) {
			return '';
		}
		let out = '';
		for (let k of Object.keys(attrs)) {
			let v = attrs[k];
			if (_.isBoolean(v)) {
				if (v) {
					out += ` ${k}`
				}
			} else {
				out += ` ${k}="${v}"`;
			}
		}
		return new SafeString(out);
	});
	env.addFilter('pretty', function (s) {
		return utils.pretty(s);
	});

	env.addGlobal('Object', Object);
	env.addGlobal('String', String);
	env.addGlobal('Array', Array);
	env.addGlobal('Boolean', Boolean);
	env.addGlobal('JSON', JSON);
	env.addGlobal('uniqueID', _.uniqueId);
};